import { useEffect, useState } from 'react';

import { TurnstileInstance } from '@frontend/api/types';
import { AGENT_TEST_RUN_INSTANCE_OVERRIDE_KEY } from '@frontend/utils/misc';

export function useTestRunInstance() {
  const [selectedInstance, setSelectedInstance] = useState<TurnstileInstance>();

  const storeSelectedInstance = (instance: TurnstileInstance | undefined) => {
    setSelectedInstance(instance);
    if (instance?.id) {
      localStorage.setItem(AGENT_TEST_RUN_INSTANCE_OVERRIDE_KEY, instance.id);
    } else {
      localStorage.removeItem(AGENT_TEST_RUN_INSTANCE_OVERRIDE_KEY);
    }
  };

  // Clear localStorage on unmount
  useEffect(() => {
    return () => {
      localStorage.removeItem(AGENT_TEST_RUN_INSTANCE_OVERRIDE_KEY);
    };
  }, []);

  return {
    selectedInstance,
    storeSelectedInstance,
  };
}
